'use strict';

var _ = require('lodash');
var BookingsIntakeTransformationService = function BookingsIntakeTransformationService(featureToggleService) {
  var CELL_HEIGHT = 20;
  var BOOKINGS_INTAKE_VALID_FIELD_NAMES = ['regularBookingsIntake', 'mappedBookingsIntake', 'segClassBookingsIntake', 'legClassBookingsIntake', 'bookingsIntake'];
  var BOOKING_PROPS_MAP = {
    regular: ['currentBookings', 'resHoldTotal', 'segClassCurrentBookings', 'bookings', 'regularReservationHoldingsTotal', 'regularMetrics.current.resHoldTotal', 'metrics.current.resHoldTotal'],
    mapped: ['currentBookings', 'resHoldTotal', 'segClassCurrentBookings', 'mappedBookings', 'mappedReservationHoldingsTotal', 'mappedMetrics.current.resHoldTotal', 'metrics.current.resHoldTotal']
  };
  var BOOKING_LY_PROPS_MAP = {
    regular: ['lastYearCurrentBookings', 'segClassLastYearCurrentBookings', 'regularLastYearCurrentBookings', 'lastYearBookings', 'regularMetrics.currentLastYear.resHoldTotal', 'metrics.currentLastYear.resHoldTotal', 'metrics.currentLastYear.bookings'],
    mapped: ['lastYearCurrentBookings', 'segClassLastYearCurrentBookings', 'mappedLastYearCurrentBookings', 'lastYearMappedBookings', 'mappedMetrics.currentLastYear.resHoldTotal', 'metrics.currentLastYear.resHoldTotal', 'metrics.currentLastYear.bookings']
  };
  var BOOKING_RY_PROPS_MAP = {
    regular: ['referenceYearCurrentBookings', 'metrics.currentReferenceYear.bookings'],
    mapped: ['referenceYearCurrentBookings', 'metrics.currentReferenceYear.bookings']
  };
  var GROUP_BOOKING_PROPS_MAP = {
    regular: ['groupBookings'],
    mapped: ['groupBookings']
  };
  var GROUP_BOOKING_LY_PROPS_MAP = {
    regular: ['lastYearGroupBookings'],
    mapped: ['lastYearGroupBookings']
  };
  var GROUP_BOOKING_RY_PROPS_MAP = {
    regular: ['referenceYearGroupBookings'],
    mapped: ['referenceYearGroupBookings']
  };
  var LF_BOOKING_PROPS_MAP = {
    regular: ['currentLoadFactor'],
    mapped: ['currentLoadFactor']
  };
  var LF_BOOKING_LY_PROPS_MAP = {
    regular: ['lastYearCurrentLoadFactor'],
    mapped: ['lastYearCurrentLoadFactor']
  };
  var LF_BOOKING_RY_PROPS_MAP = {
    regular: ['referenceYearCurrentLoadFactor'],
    mapped: ['referenceYearCurrentLoadFactor']
  };
  function getBookingsData(entry, lastYear, referenceYear, currentProps, lyProps, ryProps) {
    var propertyMap = lastYear ? lyProps : referenceYear ? ryProps : currentProps;
    var properties = featureToggleService.isEnabled('MAPPED_MODE') ? propertyMap.regular : propertyMap.mapped;
    return _.chain(properties).map(function (path) {
      return _.get(entry, path);
    }).compact().first().value();
  }
  function getBookings(entry, lastYear, referenceYear) {
    return getBookingsData(entry, lastYear, referenceYear, BOOKING_PROPS_MAP, BOOKING_LY_PROPS_MAP, BOOKING_RY_PROPS_MAP);
  }
  function getGroupBookings(entry, lastYear, referenceYear) {
    return getBookingsData(entry, lastYear, referenceYear, GROUP_BOOKING_PROPS_MAP, GROUP_BOOKING_LY_PROPS_MAP, GROUP_BOOKING_RY_PROPS_MAP);
  }
  function getLoadFactor(entry, lastYear, referenceYear) {
    return getBookingsData(entry, lastYear, referenceYear, LF_BOOKING_PROPS_MAP, LF_BOOKING_LY_PROPS_MAP, LF_BOOKING_RY_PROPS_MAP);
  }
  function getBookingsIntake(entry, fieldName) {
    var MAPPED_MODE = featureToggleService.isEnabled('MAPPED_MODE');
    return entry[fieldName] || (MAPPED_MODE ? entry.regularBookingsIntake : entry.mappedBookingsIntake);
  }
  function getClosest(curve, dtd) {
    return _.find(curve, function (item) {
      return item.daysToDeparture >= dtd;
    });
  }
  function getMinMaxBookingsIntake(data, fieldName) {
    var maxBookingsIntake = ['max' + fieldName];
    var minBookingsIntake = ['min' + fieldName];
    return _.reduce(data, function (result, item) {
      if (item[maxBookingsIntake]) {
        var maxValue = item[maxBookingsIntake].intake;
        result.max = maxValue >= result.max ? maxValue : result.max;
      }
      if (item[minBookingsIntake]) {
        var minValue = item[minBookingsIntake].intake;
        result.min = minValue <= result.min ? minValue : result.min;
      }
      return result;
    }, {
      min: 0,
      max: 0
    });
  }
  function createBookingsIntakeHtml(data) {
    var MIN_MAX_DATA = {};
    _.each(BOOKINGS_INTAKE_VALID_FIELD_NAMES, function (fieldName) {
      MIN_MAX_DATA[fieldName] = getMinMaxBookingsIntake(data, fieldName);
    });
    _.forEach(data, function (item) {
      _.each(BOOKINGS_INTAKE_VALID_FIELD_NAMES, function (bookingsIntakeFieldName) {
        var bookingsIntakeDataFieldName = bookingsIntakeFieldName + 'Data';
        var bookingsIntakeHtmlFieldName = bookingsIntakeFieldName + 'Html';
        if (item[bookingsIntakeDataFieldName]) {
          item[bookingsIntakeHtmlFieldName] = getBookingsIntakeHtml(item[bookingsIntakeDataFieldName], Math.abs(MIN_MAX_DATA[bookingsIntakeFieldName].min), MIN_MAX_DATA[bookingsIntakeFieldName].max);
        } else {
          item[bookingsIntakeHtmlFieldName] = '<div></div>';
        }
      });
    });
    return data;
  }
  function getBookingsIntakeHtml(values, minValue, maxValue) {
    var totalHeight = maxValue + minValue;
    var result = _.reduce(values, function (result, value) {
      if (value.intake) {
        var positive = value.intake >= 0;
        var height = Math.abs(value.intake) / (positive ? maxValue : minValue) * 100;
        result.positiveBars += '<div class="bar" style="height:' + (positive ? height : 0) + '%;"></div>';
        result.negativeBars += '<div class="bar" style="height:' + (!positive ? height : 0) + '%;"></div>';
      } else {
        result.positiveBars += '<div class="bar" style="height:0%;"></div>';
        result.negativeBars += '<div class="bar" style="height:0%;"></div>';
      }
      return result;
    }, {
      positiveBars: '',
      negativeBars: ''
    });
    var htmlResult = '<div></div>';
    if (result.positiveBars !== '' || result.negativeBars !== '') {
      htmlResult = '<div class="bookings-intake" style="height:' + CELL_HEIGHT + 'px"><div class="wrap positive" style="height:' + maxValue / totalHeight * 100 + '%;">' + result.positiveBars + '</div><div class="wrap negative" style="height:' + minValue / totalHeight * 100 + '%;">' + result.negativeBars + '</div></div>';
    }
    return htmlResult;
  }
  function calculateBookingsIntake(newEntry, entry, fieldName) {
    var bookingsIntakeFieldName = fieldName || 'bookingsIntake';
    var bookingsIntakeInput = getBookingsIntake(entry, bookingsIntakeFieldName);
    if (bookingsIntakeInput && bookingsIntakeInput.values) {
      var thisYearTotalBookings = getBookings(entry) || 0;
      var lastYearTotalBookings = getBookings(entry, true) || 0;
      var referenceYearTotalBookings = getBookings(entry, false, true) || 0;
      var thisYearGroupBookings = getGroupBookings(entry) || 0;
      var lastYearGroupBookings = getGroupBookings(entry, true) || 0;
      var thisYearCurrentLoadFactor = getLoadFactor(entry) || 0;
      var lastYearCurrentLoadFactor = getLoadFactor(entry, true) || 0;
      var bookingsIntakeDataFieldName = bookingsIntakeFieldName + 'Data';
      newEntry[bookingsIntakeDataFieldName] = _.chain(bookingsIntakeInput.values).sortBy(['daysToDeparture']).transform(function (result, item) {
        var thisYear = item.thisYear;
        var lastYear = item.lastYear;
        var referenceYear = item.referenceYear;
        var thisYearGrouping = item.thisYearGrouping;
        var lastYearGrouping = item.lastYearGrouping;
        var thisYearLoadFactor = item.thisYearLoadFactor;
        var lastYearLoadFactor = item.lastYearLoadFactor;
        var thisYearLowestClass = item.thisYearLowestClass;
        var lastYearLowestClass = item.lastYearLowestClass;
        var clonedItem = _.cloneDeep(item);
        var newItem = _.assign(clonedItem, {
          offset: item.daysToDeparture - entry.daysToDeparture,
          intake: _.isNil(item.thisYear) ? undefined : thisYearTotalBookings - thisYear,
          intakeLY: _.isNil(item.lastYear) ? undefined : lastYearTotalBookings - lastYear,
          intakeRY: _.isNil(item.referenceYear) ? undefined : referenceYearTotalBookings - referenceYear,
          grouping: _.isNil(item.thisYearGrouping) ? undefined : thisYearGroupBookings - thisYearGrouping,
          groupingLY: _.isNil(item.lastYearGrouping) ? undefined : lastYearGroupBookings - lastYearGrouping,
          loadFactor: _.isNil(item.thisYearLoadFactor) ? undefined : thisYearCurrentLoadFactor - thisYearLoadFactor,
          loadFactorLY: _.isNil(item.lastYearLoadFactor) ? undefined : lastYearCurrentLoadFactor - lastYearLoadFactor,
          lowestClassOpen: thisYearLowestClass,
          lowestClassOpenLY: lastYearLowestClass
        });
        result.push(newItem);
        return result;
      }, []).value();
      newEntry['min' + bookingsIntakeFieldName] = _.minBy(newEntry[bookingsIntakeDataFieldName], 'intake');
      newEntry['max' + bookingsIntakeFieldName] = _.maxBy(newEntry[bookingsIntakeDataFieldName], 'intake');
    }
    return newEntry;
  }
  function transformCurveData(curveData, thisYearTotalBookings, lastYearTotalBookings, referenceYearTotalBookings, daysToDeparture, dtdPoints) {
    return _.transform(dtdPoints, function (result, dtdPoint) {
      var thisYearDataPoint = getClosest(curveData.bookingCurveCurrentYear, dtdPoint);
      var lastYearDataPoint = getClosest(curveData.bookingCurveLastYear, dtdPoint);
      var referenceYearDataPoint = getClosest(curveData.bookingCurveReferenceYear, dtdPoint);
      var thisYearBookings = thisYearDataPoint ? thisYearDataPoint.booking : undefined;
      var lastYearBookings = lastYearDataPoint ? lastYearDataPoint.booking : undefined;
      var referenceYearBookings = referenceYearDataPoint ? referenceYearDataPoint.booking : undefined;
      result.push({
        daysToDeparture: dtdPoint,
        thisYear: thisYearBookings,
        lastYear: lastYearBookings,
        offset: dtdPoint - daysToDeparture,
        intake: !_.isNil(thisYearBookings) ? thisYearTotalBookings - thisYearBookings : undefined,
        intakeLY: !_.isNil(lastYearBookings) ? lastYearTotalBookings - lastYearBookings : undefined,
        intakeRY: !_.isNil(referenceYearBookings) ? referenceYearTotalBookings - referenceYearBookings : undefined
      });
      return result;
    }, []);
  }
  return {
    calculateBookingsIntake: calculateBookingsIntake,
    createBookingsIntakeHtml: createBookingsIntakeHtml,
    getMinMaxBookingsIntake: getMinMaxBookingsIntake,
    getBookingsIntakeHtml: getBookingsIntakeHtml,
    transformCurveData: transformCurveData,
    getClosest: getClosest
  };
};
BookingsIntakeTransformationService.$inject = ['FeatureToggleService'];
module.exports = BookingsIntakeTransformationService;